export default __webpack_public_path__ + "static/media/Tincodong_thumbnail_2.170370e3.png";